/**
 * The rows an export's "Selected rows" scope covers (owner, 30.09.2026:
 * "export only the selected rows").
 *
 * Whole-row selection when there is one, otherwise every row that has a
 * selected cell — the same rows a row gesture (Delete, Copy rows) acts on, so
 * the menu, the footer and the export always agree. Sorted, so the file keeps
 * the grid's order however the selection was made.
 */
import { parseCellKey } from '../dbGridModel';

export function selectedRowIndexes(selectedRows, selectedCells) {
  const rows = new Set(selectedRows && selectedRows.size ? selectedRows : []);
  if (rows.size === 0 && selectedCells) {
    for (const key of selectedCells) {
      const { kind, id } = parseCellKey(key);
      if (kind === 'r') rows.add(id);
    }
  }
  return [...rows].sort((a, b) => a - b);
}
